import React, { useState } from 'react';
import { CreditCard, Lock, X } from 'lucide-react';
import { motion } from 'framer-motion';

const PaymentModal = ({ lead, onClose, onConfirm }) => {
  const [processing, setProcessing] = useState(false);

  const handlePay = async (e) => {
    e.preventDefault();
    setProcessing(true);
    // Simulate Stripe Delay
    setTimeout(() => {
      onConfirm();
    }, 2000);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm p-4">
      <motion.div initial={{ scale: 0.9 }} animate={{ scale: 1 }} className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        <div className="bg-gray-900 p-6 text-white flex justify-between items-center">
          <h3 className="text-xl font-bold flex items-center"><Lock size={18} className="mr-2"/> Secure Checkout</h3>
          <button onClick={onClose}><X size={20}/></button>
        </div>
        
        <div className="p-6">
          <div className="mb-6 bg-blue-50 p-4 rounded-lg border border-blue-100">
            <p className="text-xs text-blue-600 font-bold uppercase mb-1">Purchasing Lead</p>
            <p className="text-lg font-bold text-gray-800">{lead.category}</p>
            <p className="text-sm text-gray-600">Location: {lead.city}, {lead.state}</p>
            <div className="mt-2 text-2xl font-black text-primary">${lead.price_company}</div>
          </div>

          <form onSubmit={handlePay} className="space-y-4">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Card Number</label>
              <div className="relative">
                <CreditCard className="absolute left-3 top-3 text-gray-400" size={18} />
                <input type="text" placeholder="0000 0000 0000 0000" className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none" required />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Expiry</label>
                <input type="text" placeholder="MM/YY" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none" required />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">CVC</label>
                <input type="text" placeholder="123" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none" required />
              </div>
            </div>

            <button disabled={processing} type="submit" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-lg shadow-lg transition-all flex justify-center items-center">
              {processing ? (
                <>Processing <span className="animate-spin ml-2">⏳</span></>
              ) : (
                `Pay $${lead.price_company}`
              )}
            </button>
          </form>
          
          <div className="mt-4 text-center">
            <p className="text-xs text-gray-400">Encrypted by 256-bit SSL security.</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PaymentModal;